var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { title: _vm.$t("lbl_return_from_customer") } },
    [
      _c(
        "a-form",
        {
          attrs: {
            "label-col": { span: 6 },
            "wrapper-col": { span: 7 },
            form: _vm.formFind,
            "data-testid": "return-from-customer-form"
          },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.findData.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "a-form-item",
            {
              attrs: {
                label: _vm.$t(_vm.formRuleFind.salesType.label),
                "data-testid": "return-from-customer-sales-type"
              }
            },
            [
              _c("SelectSalesType", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: _vm.formRuleFind.salesType.decorator,
                    expression: "formRuleFind.salesType.decorator"
                  }
                ],
                attrs: { disabled: _vm.disableData, mode: "CUSTOMER_RETURN" },
                on: { change: _vm.changeSalesType }
              })
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                label: _vm.$t(_vm.formRuleFind.customerName.label),
                "data-testid": "return-from-customer-select-customer"
              }
            },
            [
              _c(
                "a-select",
                {
                  directives: [
                    {
                      name: "decorator",
                      rawName: "v-decorator",
                      value: _vm.formRuleFind.customerName.decorator,
                      expression: "formRuleFind.customerName.decorator"
                    }
                  ],
                  attrs: {
                    name: _vm.formRuleFind.customerName.name,
                    placeholder: _vm.$t(
                      _vm.formRuleFind.customerName.placeholder
                    ),
                    allowClear: false,
                    showSearch: true,
                    disabled: _vm.disableData,
                    "filter-option": false
                  },
                  on: { search: _vm.searchCustomer, change: _vm.changeCustomer }
                },
                _vm._l(_vm.customerOption.data, function(item, index) {
                  return _c(
                    "a-select-option",
                    { key: index, attrs: { value: item.id } },
                    [
                      _c(
                        "a-tooltip",
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v(" " + _vm._s("" + item.fullName) + " ")
                          ]),
                          _vm._v(" " + _vm._s("" + item.fullName) + " ")
                        ],
                        2
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                label: _vm.$t(_vm.formRuleFind.returnFrom.label),
                "data-testid": "return-from-customer-return-from"
              }
            },
            [
              _c(
                "a-select",
                {
                  directives: [
                    {
                      name: "decorator",
                      rawName: "v-decorator",
                      value: _vm.formRuleFind.returnFrom.decorator,
                      expression: "formRuleFind.returnFrom.decorator"
                    }
                  ],
                  attrs: {
                    name: _vm.formRuleFind.returnFrom.name,
                    placeholder: _vm.$t(_vm.formRuleFind.returnFrom.label),
                    disabled: _vm.disableData
                  },
                  on: { change: _vm.changeReturnFrom }
                },
                _vm._l(_vm.returnFromOption.data, function(item, index) {
                  return _c(
                    "a-select-option",
                    { key: index, attrs: { value: item.value } },
                    [_vm._v(" " + _vm._s(_vm.$t(item.label)) + " ")]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                label: _vm.$t(_vm.formRuleFind.documentNumber.label),
                "data-testid": "return-from-customer-document-number"
              }
            },
            [
              _c(
                "a-select",
                {
                  directives: [
                    {
                      name: "decorator",
                      rawName: "v-decorator",
                      value: _vm.formRuleFind.documentNumber.decorator,
                      expression: "formRuleFind.documentNumber.decorator"
                    }
                  ],
                  attrs: {
                    name: _vm.formRuleFind.documentNumber.name,
                    placeholder: _vm.$t(
                      _vm.formRuleFind.documentNumber.placeholder
                    ),
                    allowClear: true,
                    showSearch: true,
                    disabled: _vm.disableData,
                    "filter-option": false,
                    loading: _vm.loading.documentNumber
                  },
                  on: { search: _vm.searchDocumentNumber }
                },
                _vm._l(_vm.dataDoOrInvoiceNumber, function(item, index) {
                  return _c(
                    "a-select-option",
                    { key: index, attrs: { value: item.id } },
                    [
                      _c(
                        "a-tooltip",
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v(" " + _vm._s("" + item.documentNumber) + " ")
                          ]),
                          _vm._v(" " + _vm._s("" + item.documentNumber) + " ")
                        ],
                        2
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "a-form-item",
            { attrs: { "wrapper-col": { span: 7, offset: 6 } } },
            [
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    "html-type": "submit",
                    disabled: _vm.disableData,
                    "data-testid": "return-from-customer-btn-find"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("lbl_find")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "a-tabs",
        [
          _c(
            "a-tab-pane",
            { key: "result", attrs: { tab: _vm.$t("lbl_result") } },
            [
              _c(
                "a-form",
                {
                  attrs: {
                    "label-col": { span: 10 },
                    "wrapper-col": { span: 14 },
                    form: _vm.formDetail,
                    "data-testid": "return-from-customer-result-form"
                  }
                },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: [16, 16] } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  _vm.formRuleResult.custName.label
                                ),
                                "data-testid":
                                  "return-from-customer-customer-name"
                              }
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value:
                                      _vm.formRuleResult.custName.decorator,
                                    expression:
                                      "formRuleResult.custName.decorator"
                                  }
                                ],
                                attrs: {
                                  name: _vm.formRuleResult.custName.name,
                                  placeholder: _vm.$t(
                                    _vm.formRuleResult.custName.placeholder
                                  ),
                                  disabled: _vm.disableDataFind
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  _vm.formRuleResult.salesOrderNumber.label
                                ),
                                "data-testid":
                                  "return-from-customer-sales-order-number"
                              }
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value:
                                      _vm.formRuleResult.salesOrderNumber
                                        .decorator,
                                    expression:
                                      "formRuleResult.salesOrderNumber.decorator"
                                  }
                                ],
                                attrs: {
                                  name:
                                    _vm.formRuleResult.salesOrderNumber.name,
                                  placeholder: _vm.$t(
                                    _vm.formRuleResult.salesOrderNumber
                                      .placeholder
                                  ),
                                  disabled: _vm.disableDataFind
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  _vm.formRuleResult.deliveryOrderNumber.label
                                ),
                                "data-testid":
                                  "return-from-customer-delivery-order-number"
                              }
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value:
                                      _vm.formRuleResult.deliveryOrderNumber
                                        .decorator,
                                    expression:
                                      "formRuleResult.deliveryOrderNumber.decorator"
                                  }
                                ],
                                attrs: {
                                  name:
                                    _vm.formRuleResult.deliveryOrderNumber.name,
                                  placeholder: _vm.$t(
                                    _vm.formRuleResult.deliveryOrderNumber
                                      .placeholder
                                  ),
                                  disabled: _vm.disableDataFind
                                }
                              })
                            ],
                            1
                          ),
                          _vm.formRuleResult.invoiceNumber.show
                            ? _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      _vm.formRuleResult.invoiceNumber.label
                                    ),
                                    "data-testid":
                                      "return-from-customer-invoice-number"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value:
                                          _vm.formRuleResult.invoiceNumber
                                            .decorator,
                                        expression:
                                          "formRuleResult.invoiceNumber.decorator"
                                      }
                                    ],
                                    attrs: {
                                      name:
                                        _vm.formRuleResult.invoiceNumber.name,
                                      placeholder: _vm.$t(
                                        _vm.formRuleResult.invoiceNumber
                                          .placeholder
                                      ),
                                      disabled: _vm.disableDataFind
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: _vm.$t(_vm.formRuleResult.branch.label),
                                "data-testid": "return-from-customer-branch"
                              }
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: _vm.formRuleResult.branch.decorator,
                                    expression:
                                      "formRuleResult.branch.decorator"
                                  }
                                ],
                                attrs: {
                                  name: _vm.formRuleResult.branch.name,
                                  placeholder: _vm.$t(
                                    _vm.formRuleResult.branch.placeholder
                                  ),
                                  disabled: _vm.disableDataFind
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  _vm.formRuleResult.deliveryOrderDate.label
                                ),
                                "data-testid":
                                  "return-from-customer-delivery-order-date"
                              }
                            },
                            [
                              _c("a-date-picker", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value:
                                      _vm.formRuleResult.deliveryOrderDate
                                        .decorator,
                                    expression:
                                      "formRuleResult.deliveryOrderDate.decorator"
                                  }
                                ],
                                staticStyle: { width: "100%" },
                                attrs: {
                                  name:
                                    _vm.formRuleResult.deliveryOrderDate.name,
                                  placeholder:
                                    _vm.formRuleResult.deliveryOrderDate
                                      .placeholder,
                                  format: _vm.DEFAULT_DATE_FORMAT,
                                  disabled: _vm.disableDataFind
                                }
                              })
                            ],
                            1
                          ),
                          _vm.formRuleResult.invoiceDate.show
                            ? _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      _vm.formRuleResult.invoiceDate.label
                                    ),
                                    "data-testid":
                                      "return-from-customer-invoice-date"
                                  }
                                },
                                [
                                  _c("a-date-picker", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value:
                                          _vm.formRuleResult.invoiceDate
                                            .decorator,
                                        expression:
                                          "formRuleResult.invoiceDate.decorator"
                                      }
                                    ],
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      name: _vm.formRuleResult.invoiceDate.name,
                                      placeholder:
                                        _vm.formRuleResult.invoiceDate
                                          .placeholder,
                                      format: _vm.DEFAULT_DATE_FORMAT,
                                      disabled: _vm.disableDataFind
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.mode !== "create"
                            ? _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      _vm.formRuleResult.returnNumber.label
                                    ),
                                    "data-testid":
                                      "return-from-customer-return-number"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value:
                                          _vm.formRuleResult.returnNumber
                                            .decorator,
                                        expression:
                                          "formRuleResult.returnNumber.decorator"
                                      }
                                    ],
                                    attrs: {
                                      name:
                                        _vm.formRuleResult.returnNumber.name,
                                      placeholder: _vm.$t(
                                        _vm.formRuleResult.returnNumber
                                          .placeholder
                                      ),
                                      disabled: _vm.disableData
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  _vm.formRuleResult.returnDate.label
                                ),
                                "data-testid":
                                  "return-from-customer-return-date"
                              }
                            },
                            [
                              _c("a-date-picker", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value:
                                      _vm.formRuleResult.returnDate.decorator,
                                    expression:
                                      "formRuleResult.returnDate.decorator"
                                  }
                                ],
                                staticStyle: { width: "100%" },
                                attrs: {
                                  name: _vm.formRuleResult.returnDate.name,
                                  placeholder:
                                    _vm.formRuleResult.returnDate.placeholder,
                                  format: _vm.DEFAULT_DATE_FORMAT,
                                  "disabled-date": _vm.disabledDate,
                                  disabled: ""
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: _vm.$t(_vm.formRuleResult.notes.label),
                                "data-testid": "return-from-customer-notes"
                              }
                            },
                            [
                              _c("a-textarea", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: _vm.formRuleResult.notes.decorator,
                                    expression: "formRuleResult.notes.decorator"
                                  }
                                ],
                                attrs: {
                                  name: _vm.formRuleResult.notes.name,
                                  placeholder: _vm.$t(
                                    _vm.formRuleResult.notes.placeholder
                                  ),
                                  disabled: _vm.disableData,
                                  rows: 4
                                }
                              }),
                              _c("character-length", {
                                attrs: {
                                  value: _vm.formDetail.getFieldValue("notes")
                                }
                              })
                            ],
                            1
                          ),
                          !!_vm.journalNumber.id
                            ? _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      _vm.formRuleResult.journalNumber.label
                                    ),
                                    "data-testid":
                                      "return-from-customer-journal-number"
                                  }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "generaljournal.detail",
                                          params: { id: _vm.journalNumber.id }
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "a-button",
                                        { attrs: { type: "link" } },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.journalNumber.name) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formRuleResult.refundOption.show
                            ? _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      _vm.formRuleResult.refundOption.label
                                    ),
                                    "data-testid":
                                      "return-from-customer-refund-option"
                                  }
                                },
                                [
                                  _c(
                                    "a-radio-group",
                                    {
                                      directives: [
                                        {
                                          name: "decorator",
                                          rawName: "v-decorator",
                                          value:
                                            _vm.formRuleResult.refundOption
                                              .decorator,
                                          expression:
                                            "formRuleResult.refundOption.decorator"
                                        }
                                      ],
                                      attrs: {
                                        name:
                                          _vm.formRuleResult.refundOption.label,
                                        disabled: _vm.disableData
                                      }
                                    },
                                    _vm._l(_vm.refundOptions, function(
                                      item,
                                      idx
                                    ) {
                                      return _c(
                                        "a-radio",
                                        {
                                          key: idx,
                                          attrs: { value: item.value }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t(item.label)) +
                                              " "
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                { attrs: { gutter: [16, 16] } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c("TableCustom", {
                        attrs: {
                          size: "small",
                          idTable: "tablereturnfromcustomer",
                          dataSource: _vm.dataListItems,
                          columns: _vm.columnsTable,
                          paginationcustom: false,
                          defaultPagination: {
                            showTotal: function(total) {
                              return _vm.$t("lbl_total_items", { total: total })
                            }
                          },
                          loading: _vm.loading.table,
                          scroll: { x: 1600 },
                          handleInput: _vm.handleInput,
                          handleSelect: _vm.handleSelect,
                          handleSearchSelectTable: _vm.handleSearchSelectTable,
                          "data-testid": "return-from-customer-table"
                        }
                      }),
                      _c(
                        "div",
                        { staticClass: "mt-2 text-right" },
                        [
                          _c(
                            "a-space",
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    "data-testid":
                                      "return-from-customer-btn-back"
                                  },
                                  on: { click: _vm.cancel }
                                },
                                [_vm._v(_vm._s(_vm.$t("lbl_back")))]
                              ),
                              _vm.$can("create", "sales-return")
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        loading: _vm.loading.save,
                                        disabled: _vm.disableData,
                                        "data-testid":
                                          "return-from-customer-btn-save"
                                      },
                                      on: { click: _vm.save }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("lbl_submit")))]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }